export function getOpacity(transformer) {
    return Object.freeze({
        pointFive: transformer.opacity(0.5),
        pointSeven: transformer.opacity(0.7),
    });
}
